/* eslint-disable react/prop-types */
import React from "react";
import DatePicker from "react-flatpickr";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import { Box, Typography } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftInput from "components/SoftInput";
import SwitchBox from "components/SwitchBox";
import SoftTypography from "components/SoftTypography";

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
};

const ModalContent = ({ list, pickAll, setPickAll, handleChangeSwitch }) => {
  const [taxPeriod, setTaxPeriod] = React.useState("quarterly"); // | time
  const [taxType, setTaxType] = React.useState("firstTime"); // | additional

  return (
    <>
      <Box
        sx={{
          p: 1,
          border: "1px solid black",
          borderRadius: 1,
        }}
      >
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Chọn kỳ tính thuế
        </Typography>
        <SoftBox display="flex" flexDirection="column" my={1}>
          <SoftTypography component="label" variant="caption" fontWeight="bold" mb={0.5}>
            QT cấp cục
          </SoftTypography>
          <select style={selectStyle}>
            <option value="1">CTH - cục thuế Thành phố Cần Thơ</option>
            <option value="2">AGI - Cục thuế An giang</option>
          </select>
        </SoftBox>
        <SoftBox display="flex" flexDirection="column" my={1}>
          <SoftTypography component="label" variant="caption" fontWeight="bold" mb={0.5}>
            CQT nơi nộp
          </SoftTypography>
          <select style={selectStyle}>
            <option value="1">CTH - cục thuế Thành phố Cần Thơ</option>
            <option value="2">AGI - Cục thuế An giang</option>
          </select>
        </SoftBox>
        <Box>
          <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
            <SoftTypography component="label" variant="caption" fontWeight="bold">
              Từ ngày
            </SoftTypography>
          </SoftBox>
          <DatePicker
            options={{
              locale: Vietnamese,
              time_24hr: true,
              dateFormat: "d-m-Y",
            }}
            render={({ defaultValue }, ref) => (
              <SoftInput defaultValue={defaultValue} inputRef={ref} />
            )}
          />
        </Box>
        <Box
          sx={{
            p: 1,
            border: "1px solid black",
            borderRadius: 1,
            mt: 1,
          }}
        >
          <SwitchBox
            checked={pickAll}
            // onChange={(e) => setPickAll(e.target.checked)}
            label="Chọn phụ lục kê khai"
          />
          <Box
            sx={{
              mt: 1,
              p: 1,
              maxHeight: 200,
              overflow: "auto",
              borderRadius: 1,
              border: "1px solid black",
            }}
          >
            {list.map((item, index) => (
              <SwitchBox
                name={item.name}
                checked={pickAll ? pickAll : item.checked}
                onChange={(e) => handleChangeSwitch(item.name, e.target.checked)}
                key={index}
                label={item.name}
              />
            ))}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ModalContent;
